import CreateEditUser from "../../Components/UserManagement/CreateEditUser";

export default function UserCreateEdit() {
    return (
        <CreateEditUser />
    )
}